<template>
  <div>
    <h3>미션달성형 > 등록/조회</h3>
    <b-card header="미션 달성 목록">
      <b-row class="mb-1">
        <b-col>
          <b-nav pills>
            <b-nav-item v-for="(item, index) in navItems" v-bind:key="item.id"
                        :active="currentNavItem===index"
                        @click="navClicked(index, item)">
              {{item.text}}
            </b-nav-item>
          </b-nav>
        </b-col>
        <b-col>
          <b-input-group prepend="통합검색">
            <b-form-input placeholder="캠페인명 또는 게임명 또는 광고주명으로 검색" v-model="searchText">

            </b-form-input>
            <b-input-group-append>
              <b-button>
                검색
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-button class="mb-1 pull-right" to="new" variant="primary">캠페인 등록하기</b-button>
      <b-table id="mission-table"
               :fields="tableFields"
               :items="filteredTableItems"
               :per-page="perPage"
               :current-page="currentPage"
               primary-key="id"
               sort-by="modifiedAt"
               :sort-desc="true">
        <template slot="name" slot-scope="data">
          <router-link :to="data.item.id.toString()">{{data.value}}</router-link>
        </template>

        <!--<template slot="startAt" slot-scope="data">-->
        <!--{{timeFormatter(data.value)}}-->
        <!--</template>-->
        <!--<template slot="endAt" slot-scope="data">-->
        <!--{{timeFormatter(data.value)}}-->
        <!--</template>-->
        <!--<template slot="modifiedAt" slot-scope="data">-->
        <!--{{timeFormatter(data.value)}}-->
        <!--</template>-->

        <template slot="manage" slot-scope="data">
          <router-link :to="data.item.id.toString()">[조회]</router-link>
          <router-link v-if="!data.item.isEnded()"
                       :to="data.item.id.toString()+'/edit'">[수정]
          </router-link>
          <router-link v-if="data.item.isScheduled()"
                       to="#" @click.native="deleteMission(data.item)">[삭제]
          </router-link>
        </template>
      </b-table>
      <b-pagination
        :per-page="perPage"
        v-model="currentPage"
        :total-rows="filteredTableItems.length"
        aria-controls="mission-table">

      </b-pagination>
    </b-card>
  </div>
</template>

<script>

  import adMasterApi from "@/common/gap/api/adMasterApi.js";
  import missionApi from "@/common/gap/api/missionApi.js";
  import AdAccountSelector from "../AdAccountSelector";
  import gapmoment from "@/common/gap/util/gapmoment";
  import Mission, {MISSION_ENDED, MISSION_ONGOING, MISSION_SCHEDULED} from "@/common/gap/model/mission";

  export default {
    components: {AdAccountSelector},
    props: {
      adAccount: null
    },
    data() {
      return {
        content: "미션 달성 목록",
        searchText: "",
        perPage: 10,
        currentNavValue: "ALL",
        currentNavItem: 0,
        currentPage: 1,
        navItems: [
          {text: "전체", value: "ALL"},
          {text: "진행중", value: MISSION_ONGOING},
          {text: "예정", value: MISSION_SCHEDULED},
          {text: "종료", value: MISSION_ENDED},
        ],
        tableFields: [
          {key: "codeName", label: "코드 이름", class: "truncate"},
          {key: "name", label: "캠페인명", class: "truncate", sortable:true},
          {key: "advertiserName", label: "광고주명"},
          {key: "startAt", label: "시작일", sortable:true, formatter: value => this.timeFormatter(value)},
          {key: "endAt", label: "종료일", sortable:true, formatter: value => this.timeFormatter(value)},
          {key: "status", label: "상태", formatter: (value, key, item) => this.statusText(item)},
          {key: "modifiedAt", label: "등록/수정일", sortable:true, formatter: value => gapmoment.kstToLtz(this.timeFormatter(value))},
          {key: "modifiedBy", label: "등록/수정자", sortable:true},
          {key: "manage", label: "관리"},
        ],
        tableItems: []
      }
    },
    mounted() {
      this.loadTableItems();
    },
    methods: {
      navClicked(index, navItem) {
        this.currentNavItem = index;
        this.currentNavValue = navItem.value;
      },
      loadTableItems() {
        if (!this.adAccount) {
          return;
        }
        adMasterApi.getCampaigns(this.adAccount.id)
            .then(response => {
              const campaignList = response.data.data;
              this.tableItems = [];
              missionApi.getMissionsByCampaignIds(
                  campaignList.map(elm => elm.id)
              ).then(
                  response => {
                    this.tableItems = response.data.data.missions
                        .map(elm => new Mission(elm));
                  }
              );
            });
      },
      timeFormatter(timeData) {
        return timeData.replace('T', ' ');
      },
      statusText(mission) {
        if (mission.isOnGoing()) {
          return "진행중";
        } else if (mission.isScheduled()) {
          return "예정";
        } else if (mission.isEnded()) {
          return "종료";
        }
      },
      async deleteMission(mission) {
        if (confirm("정말 삭제합니까? 되돌릴 수 없습니다.")) {
          await missionApi.deleteMission(mission);
          this.loadTableItems();
        }
      }
    },
    computed: {
      filteredTableItems() {
        const now = Date.now();
        return this.tableItems
            .filter(//이름필터
                    (item) => item.name.includes(this.searchText) ||
                              item.advertiserName.includes(this.searchText) ||
                              item.gameName.includes(this.searchText)
            )
            .filter(//날짜 필터
                    (item) => {
                      switch (this.currentNavValue) {
                      case "ALL":
                        return true;
                      case "ONGOING":
                        return item.isOnGoing();
                      case "SCHEDULED":
                        return item.isScheduled();
                      case "ENDED":
                        return item.isEnded();
                      }
                    }
            );
      }
    },
    watch: {
      adAccount: {
        handler(newVal, oldVal) {
          if (newVal) {
            this.loadTableItems();
          }
        },
        deep: true
      }
    }
  }
</script>

<style>
  .truncate {
    max-width: 250px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
